export const nav = [
  {
    text: "home",
    path: "/",
  },
  {
    text: "about",
    path: "/about",
  },
   {
    text: "inspiration",
    path: "/inspiration",
  },
  {
    text: "Need",
    path: "/need",
  },
  {
    text: "blog",
    path: "/blog",
  },
  {
    text: "Partners",
    path: "/price",
  },
  {
    text: "contact",
    path: "/contact",
  },
]
export const featured = [
  {
    cover: "../images/hero/h1.png",
    name: "Mitigating Female Genital Mutilation and Gender-Based Violence",
    total: "",
  },
  {
    cover: "../images/hero/h2.png",
    name: "Championing Education Access for Girls and Young Women",
    total: "",
  },
  {
    cover: "../images/hero/h3.png",
    name: "Rebuilding Livelihoods for Young Widows of Conflict",
    total: "",
  },
  // {
  //   cover: "../images/hero/h4.png",
  //   name: "Advancing Health Equity for HIV-Affected Women and Mothers",
  //   total: "Enlightenment",
  // },
  // {
  //   cover: "../images/hero/h6.png",
  //   name: "Preventing Malnutrition in Vulnerable Children Under 5",
  //   total: "Live",
  // },
  {
    cover: "../images/hero/h4.png",
    name: "Building Capacity for Climate Change and Agriculture",
    total: "",
  },
  {
    cover: "../images/hero/h6.png",
    name: "Building Partnerships for Community Change",
    total: "",
  },
]
export const list = [
  {
    id: 1,
    cover: "../images/list/outdoor-mentorship.jpeg",
    name: "Outdoor Mentorship Session at The Gwitembe Comprehensive School.",
  },
  {
    id: 2,
    cover: "../images/list/conflict-aff.jpeg",
    name: "Gwitembe’s young conflict-affected widows united in solidarity, shaping their future with MRF’s support..",
  },
  {
    id: 3,
    cover: "../images/list/widow2.jpeg",
    name: "A widowed community leader embraces the youngest and recently widowed woman, reflecting the vital role of peer support and intergenerational solidarity in the face of loss.",
  },
  {
    id: 4,
    cover: "../images/list/trees2.jpeg",
    name: "The MRF team nurturing a generation of climate-conscious girls through hands-on tree planting and environmental stewardship.",
  },
  {
    id: 5,
    cover: "../images/list/change.jpeg",
    name: "We don't just believe in change. We become part of it.",
  },
  {
    id: 6,
    cover: "../images/list/inside-hse.jpeg",
    name: "A young widow in Gwitembe recounts the killing of her husband, the flight from her home, and the profound changes that followed.",
  },
   {
    id: 7,
    cover: "../images/list/all.jpeg",
    name: "Small acts of dignity support. Lifelong impact.",
  },
  {
    id: 8,
    cover: "../images/list/lessons.jpeg",
    name: "Some of the most important lessons are shared, not taught.",
  },
  {
    id: 9,
    cover: "../images/list/gitwembe-team.jpeg",
    name: "One team, one purpose, showing up for the women and families of Gwitembe.",
  },
]

export const location = [
  {
    id: 1,
    name: "Sharing Sanitary Pads",
    Villas: "Kibera",
    Apartments: "Kasarani",
    cover: "./images/location/noshame.jpeg",
  },
  {
    id: 2,
    name: "Sponsoring children",
    Villas: "Kibera",
    Apartments: "Kuria",
    cover: "./images/location/future.jpg",
  },
  {
    id: 3,
    name: "Stopping FGM",
    Villas: "Kuria",
    cover: "./images/location/fgm2.jpg",
  },
  {
    id: 4,
    name: "Planting Trees",
    Villas: "Plant a tree, plant a future",
    cover: "./images/location/pboke.jpeg",
  },
  {
    id: 5,
    name: "Nairobi, Kenya",
    Villas: "Protecting the Environment",
    Apartments: "Inspiring",
    cover: "./images/location/boke-milly.jpeg",
  },
  {
    id: 6,
    name: "Nairobi Slums",
    Villas: "Repairing Houses",
    Apartments: "Shelter",
    cover: "./images/location/slums.jpg",
  },
]
export const team = [
  {
    list: "50",
    cover: "../images/customer/jeda.jpeg",
    address: "Liverpool, Canada",
    name: "Jeridah: Founder",
    icon: [<i class='fa-brands fa-facebook-f'></i>, <i class='fa-brands fa-linkedin'></i>, <i class='fa-brands fa-twitter'></i>, <i class='fa-brands fa-instagram'></i>],
  },
  {
    list: "70",
    cover: "../images/customer/boke.jpeg",
    address: "Montreal, Canada",
    name: "Maritha Boke: Co-Founder",
    icon: [<i class='fa-brands fa-facebook-f'></i>, <i class='fa-brands fa-linkedin'></i>, <i class='fa-brands fa-twitter'></i>, <i class='fa-brands fa-instagram'></i>],
  },
  {
    list: "80",
    cover: "../images/customer/prudence.jpeg",
    address: "Denever, USA",
    name: "Susan: Co-Founder",
    icon: [<i class='fa-brands fa-facebook-f'></i>, <i class='fa-brands fa-linkedin'></i>, <i class='fa-brands fa-twitter'></i>, <i class='fa-brands fa-instagram'></i>],
  },
]
export const price = [
  {
    plan: "One Time projects",
    price: "29",
    list: [
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Stop Hunger Crisis",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Uplifting Communities",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Eradicate Poverty",
      },
      { change: "color", icon: <i class='fa-solid fa-x'></i>, text: "Personal Help Support" },
      { change: "color", icon: <i class='fa-solid fa-x'></i>, text: "Enterprise SLA" },
    ],
  },
  {
    best: "Best Value",
    plan: "Yearly projects",
    price: "49",
    list: [
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Small Subsiquent Farming",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Housing Support",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Small Businesses Startup",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Personal Help Support",
      },
      {
        change: "color",
        icon: <i class='fa-solid fa-x'></i>,
        text: "Enterprise SLA",
      },
    ],
  },
  {
    plan: "Core Programs",
    price: "79",
    list: [
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Stop FGM in Kenya",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Supply Pads in Slums",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Sponshorship Programs",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Personal Help Support",
      },
      {
        icon: <i class='fa-solid fa-check'></i>,
        text: "Enterprenureship trainings",
      },
    ],
  },
]
export const footer = [
  {
    title: "LAYOUTS",
    text: [{ list: "Home Page" }, { list: "About Page" }, { list: "Service Page" }, { list: "Property Page" }, { list: "Contact Page" }, { list: "Single Blog" }],
  },
  {
    title: "ALL SECTIONS",
    text: [{ list: "Headers" }, { list: "Features" }, { list: "Attractive" }, { list: "Testimonials" }, { list: "Videos" }, { list: "Footers" }],
  },
  {
    title: "COMPANY",
    text: [{ list: "About" }, { list: "Blog" }, { list: "Programs" }, { list: "Affiliate" }, { list: "Partners" }, { list: "Take Action" }],
  },
]
